export const getOnlyAlphanumeric = string =>
  string?.toUpperCase().replace(/[^0-9A-Z]/g, '');
